module.exports = "/_next/static/videos/9-74623bf4e866c6e0e918d695740c9b26.webm";